import React, { Fragment, useState } from "react";

const OfflineRequest = ({ properties, onCloseModal }) => {
  const { reference, handleSubmit, loading, handleReject } = properties;

  const submitHandleApprove = (e) => {
    e.preventDefault();
    handleSubmit({ reference: reference, comment: comment });
  };
  const submitHandleReject = (e) => {
    e.preventDefault();
    handleReject({ reference: reference, comment: comment });
  };
  const [comment, setComment] = useState("");

  return (
    <div
      className="AuditTrailModal Modal__content"
      style={{ overflow: "hidden" }}
    >
      <div className="Modal__body">
        <Fragment>
          <h3 className="Modal__title p-b-1">Offline Request</h3>
          <hr />  
          <form onSubmit={submitHandleApprove}>
            <div className="row">
              <div className="col-12 mb-1">
                <label>Referrence</label>
                <input
                  type="text"
                  className="form-control"
                  name="reference"
                  defaultValue={reference}
                  disabled
                ></input>
              </div>
              <div className="col-12 mb-1">
                <label>Comment</label>
                <input
                  type="text"
                  className="form-control"
                  name="comment"
                  defaultValue={comment}
                  onChange={(e) => setComment(e.target.value)}
                ></input>
              </div>
              <div className="col-12 d-flex justify-content-end flex-wrap">
                <button
                  className="btn advancly-btn btn-sm transition-3d-hover mt-2 mr-2"
                  type="button"
                  disabled={loading || !comment || !reference}
                  onClick={submitHandleApprove}
                >
                  Approve
                </button>
                <button
                  className="btn advancly-dimred-btn btn-sm transition-3d-hover mt-2"
                  type="submit"
                  disabled={loading || !comment || !reference}
                  onClick={submitHandleReject}
                >
                  Reject
                </button>
              </div>
            </div>
          </form>
        </Fragment>
      </div>
    </div>
  );
};
export default OfflineRequest;
